import { ListItem, Box, Text, Skeleton } from "@chakra-ui/react";
import { useMemo } from "react";

export default function DetailItem(props) {
  const { _title, _value, itemTitle, value, isLoading, ...xprops } = props;

  const isReactChild = useMemo(() => typeof value !== "string", [value]);

  return (
    <ListItem
      bg="#FCFCFC"
      py="10px"
      px="24px"
      borderBottom="1px solid #EAEAEA4f"
      {...xprops}
    >
      <Box>
        <Skeleton
          isLoaded={!isLoading ? true : false}
          w="fit-content"
          mb={isLoading ? "2px" : 0}
          maxH={isLoading ? "12px" : "fit-content"}
        >
          <Text fontSize="12px" color="#4E4B66" fontWeight="400" {..._title}>
            {itemTitle}
          </Text>
        </Skeleton>
        <Skeleton
          isLoaded={!isLoading ? true : false}
          w="fit-content"
          maxH={isLoading ? "16px" : "fit-content"}
        >
          {!isReactChild && (
            <Text fontSize="md" fontWeight="400" color="#14142B" {..._value}>
              {value}
            </Text>
          )}

          {isReactChild && value}
        </Skeleton>
      </Box>
    </ListItem>
  );
}
